/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authenticatedEndpointTest } from '../fn/auth/authenticated-endpoint-test';
import { AuthenticatedEndpointTest$Params } from '../fn/auth/authenticated-endpoint-test';
import { getProfile } from '../fn/auth/get-profile';
import { GetProfile$Params } from '../fn/auth/get-profile';
import { ProfileResponse } from '../models/profile-response';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authenticatedEndpointTest()` */
  static readonly AuthenticatedEndpointTestPath = '/auth/authenticated-endpoint-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticatedEndpointTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticatedEndpointTest$Response(params?: AuthenticatedEndpointTest$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return authenticatedEndpointTest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticatedEndpointTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticatedEndpointTest(params?: AuthenticatedEndpointTest$Params, context?: HttpContext): Observable<string> {
    return this.authenticatedEndpointTest$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getProfile()` */
  static readonly GetProfilePath = '/auth/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfile$Response(params?: GetProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
    return getProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfile(params?: GetProfile$Params, context?: HttpContext): Observable<ProfileResponse> {
    return this.getProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileResponse>): ProfileResponse => r.body)
    );
  }

}
